import React, { useEffect, Suspense, useState } from "react";
import { BrandPageWrapper } from "../../containers/AllBrands/AllBrands.style";
import {
  productCategory,
  ProductModalData,
  searchSuggestions,
  searchStoreProduct,
  getProductsMappedwithSubCat,
  getProductsMappedwithCat,
  getProductOutOfStock,
  getProductOutOfStockCat,
  getProductBrands,
  getProductFilterBrands,
  getSortProductsName,
  getSortProductsPrice,
  sortByNameProduct,
  Reset_Suggestions,
  changePage,
  resetPage,
  productSelection,
  productSelectionFilter,
} from "../../store/actions/productAction";
import { offerSlider } from "../../store/actions/globalAction";
import { oosModified } from "../../store/actions/globalAction";
import Products from "./components/Products/Products";
import CartPopUp from "../../containers/Cart/CartPopUp";
import LazyLoader from "../../components/LazyLoader/LazyLoader";
import "../product-info.css";
import { MainContentArea, SidebarSection, ContentSection } from "./pages.style";
import { useDeviceType } from "../../helper/useDeviceType";
import { connect } from "react-redux";
import API from "../../network/redAPI";
import { Grid, Typography } from "@material-ui/core";
import { Breadcrumb, BreadcrumbItem, Spinner } from "react-bootstrap";
import { Button as MButton } from "@material-ui/core";
import t from "../../i18n/translate";
import { Tune } from "@material-ui/icons";
import { useCart } from "../../contexts/cart/use-cart";
import { useFavorites } from "../../contexts/favorites/use-favorites";
import { useLocation, useHistory, useParams } from "react-router-dom";
import DelishoLogo from "../../assets/icons/delishop_logo2.svg";
import { logEventView } from "../../services/googleAnalytics";
import Notfound from "../notfound";
const PAGE_TYPE = "grocery";
const LandingPartnerPage = (props, { userAgent }) => {
  const deviceType = useDeviceType(userAgent);
  let getPageType = window.location.pathname.split("/")[1] == "page" ? "landing" : "partner";
  const { fetchOrderItems } = useCart();
  const { fetchFavorites } = useFavorites();
  const [limit, setLimit] = useState(50);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(null);
  let history = useHistory();
  const location = useLocation();
  const params = useParams();
  let slug = params?.slug;
  const [showFilter, setShowFilter] = useState(false);
  const Param = new URLSearchParams(location.search);
  const [queryFilter, setQueryFilter] = useState({});
  const [selected, setSelected] = useState([]);
  const [selectedCat, setSelectedCat] = useState([]);
	const [selectedSubCat, setSelectedSubCat] = useState([]);
	const [selectedDietary, setSelectedDietary] = useState([]);
  const [filterShow, setFilterShow] = useState(false);

  const getProducts = async (query = {}) => {
    props.productSelection(slug, props.page, limit, query);
  };

  const getProductsFilter = async (query = {}) => {
    props.productSelectionFilter(slug, props.page, limit, query);
  };
  const [allSelected, setAllSelected] = useState({});

  const catId = Param.get("cat_id")?.split(",");
  const subCatId = Param.get("sub_cat_id")?.split(",");
  const brandId = Param.get("brand_id")?.split(",");
  const oos = Param.get("oos");
  const min = Param.get("min");
  const max = Param.get("max");
	const priority = Param.get("priority");
	const diet = Param.get("diet_id")?.split(",");
  const sort = Param.get("sort");
  const promotion = Param.get("promotion");
  const isSmallScreen = window.innerWidth <= 992;
  const countryId = Param.get("country_id")?.split(",");


	const getSearchQuery = async () => {
    // Create a new object for allSelected
    const newAllSelected = {};

    // Handle brands
    if (brandId && brandId.length > 0 && brandId[0] !== "") {
      const brands = brandId.map((i) => ({
        value: Number(i),
        label: i,
      }));
      newAllSelected.brands = brands;
      newAllSelected.brand_id = brandId;
    } else {
      newAllSelected.brands = [];
    }

    // Handle categories
    if (catId && catId.length > 0 && catId[0] !== "") {
      const categories = catId.map((i) => ({
        value: Number(i),
        label: i,
      }));
      newAllSelected.category = categories;
      newAllSelected.cat_id = catId;
    } else {
      newAllSelected.category = [];
    }

		if (diet && diet.length > 0 && diet[0] !== "") {
			console.log(diet)
			const dietId = diet.map((i) => ({
				value: Number(i),
				label: i,
			}));
			console.log(dietId)
			newAllSelected.dietary = dietId;
			newAllSelected.diet_id = diet;
		} else {
			newAllSelected.dietary = [];
		}

    // Handle subcategories
    if (subCatId && subCatId.length > 0 && subCatId[0] !== "") {
      const subCategories = subCatId.map((i) => ({
        value: Number(i),
        label: i,
      }));
      newAllSelected.sub_category = subCategories;
      newAllSelected.sub_cat_id = subCatId;
    }

    // Handle countries
    if (countryId && countryId.length > 0 && countryId[0] !== "") {
      const countries = countryId.map((i) => Number(i));
      newAllSelected.country_id = countries;
    }

    // Other parameters
    newAllSelected.min = min || 0;
    newAllSelected.max = max || 1000;
    newAllSelected.isFilter = true;
    newAllSelected.priority = priority || 0;
    newAllSelected.sort =
      sort && sort !== "undefined" && sort !== "null" ? sort : "";
    newAllSelected.check = oos === "false"; // Assuming oos is a boolean flag
    newAllSelected.promotion = promotion;
    setAllSelected(newAllSelected);
    getProductsFilter(newAllSelected);
    // Update the filter state
    setQueryFilter({
      ...newAllSelected,
      brand_id: brandId?.map((brand) => brand), // Mapping brand IDs
      cat_id: catId?.map((cat) => cat), // Mapping category IDs
      sub_cat_id: subCatId?.map((sub_cat) => sub_cat), // Mapping subcategory IDs
	    country_id: newAllSelected?.country_id, // Already handled above
	    diet_id: diet?.map((di) => di), // Already handled above
    });
  };

  const setSelectedBrands = (
    values = selected,
    catValues = selectedCat,
    SubCatValues = selectedSubCat,
    countries = [],
    min = 0,
    max = 1000,
    is_filter = filterShow,
    priority = 0,
    promotion,
    sort,
    check = oos,
    DietaryValues = [],
  ) => {
    setFilterShow(false);
    localStorage.setItem("isfilter", true);

    const updatedAllSelected = {
      brands: values,
      category: catValues,
	    sub_category: SubCatValues,
	    dietary: DietaryValues,
      min: min,
      max: max,
      isFilter: is_filter,
      priority: priority ? 1 : 0,
      promotion: promotion,
      sort: sort,
      oos: check,
      country_id:
	      countries?.length > 0 && countries?.map((country) => country.value),
      cat_id: catValues.length > 0 && catValues.map((cat) => cat?.value),
      sub_cat_id:
        SubCatValues.length > 0 &&
        SubCatValues.map((sub_cat) => sub_cat?.value),
	    brand_id: values.length > 0 && values.map((brand_id) => brand_id?.value),
	    diet_id: DietaryValues?.length > 0 && DietaryValues?.map((dit) => dit?.value),
    };
    // Update state with the new object
    setAllSelected(updatedAllSelected);

    // Update URL params based on selected filters
    if (updatedAllSelected.category?.length > 0) {
      Param.set("cat_id", updatedAllSelected.cat_id);
    } else {
      Param.delete("cat_id");
    }

    if (updatedAllSelected.sub_category?.length > 0) {
      Param.set("sub_cat_id", updatedAllSelected.sub_cat_id);
    } else {
      Param.delete("sub_cat_id");
    }

	  if (updatedAllSelected.dietary?.length > 0) {
		  Param.set("diet_id", updatedAllSelected.diet_id);
	  } else {
		  Param.delete("diet_id");
	  }

    if (updatedAllSelected.brands?.length > 0) {
      Param.set(
        "brand_id",
        updatedAllSelected.brands.map((brand) => brand.value)
      );
    } else {
      Param.delete("brand_id");
    }

    if (updatedAllSelected.oos) {
      Param.set("oos", updatedAllSelected.oos);
    } else {
      Param.delete("oos");
    }

    if (updatedAllSelected.min > 0) {
      Param.set("min", updatedAllSelected.min);
    } else {
      Param.delete("min");
    }

    if (updatedAllSelected.max < 1000) {
      Param.set("max", updatedAllSelected.max);
    } else {
      Param.delete("max");
    }

    if (updatedAllSelected.priority) {
      Param.set("priority", updatedAllSelected.priority);
    } else {
      Param.delete("priority");
    }

    if (updatedAllSelected.sort) {
      Param.set("sort", updatedAllSelected.sort);
    } else {
      Param.delete("sort");
    }
    if (updatedAllSelected.promotion) {
      Param.set("promotion", updatedAllSelected.promotion);
    } else {
      Param.delete("promotion");
    }
    if (updatedAllSelected.country_id?.length > 0) {
      Param.set("country_id", updatedAllSelected.country_id);
    } else {
      Param.delete("country_id");
    }

    // Update the URL without reloading the page
    const newUrl = `${window.location.pathname}?${Param.toString()}`;
    getProductsFilter(updatedAllSelected);
	  console.log(updatedAllSelected)
    history.replace(newUrl);
  };

  const openFilterModal = () => {
    setShowFilter(!showFilter);
  };

  const breadCrumbMatch = () => {
    return (
      <>
        <Breadcrumb.Item
          href={"/"}
          className="bread_crumb_wrapper"
          active
          style={{ display: "flex", alignItems: "center" }}
        >
          <span className="pr-1" style={{ color: "#9cc54b" }}>
            {window.location.pathname.split("/")[1]}
          </span>{" "}
          /{" "}
          <span className="pl-1" style={{ color: "#9cc54b" }}>
            {slug}
          </span>
        </Breadcrumb.Item>
      </>
    );
  };

  useEffect(() => {
    if (showFilter === false) {
      localStorage.removeItem("isfilter");
    } else {
      localStorage.setItem("isfilter", true);
    }
  }, [showFilter]);
  const CenteredSpinner = () => {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
        }}
      >
        <Spinner animation="border" style={{ color: "#9cc54b" }} />
      </div>
    );
  };

  useEffect(() => {
    props.getProductBrands();
    localStorage.removeItem("mode");
    localStorage.removeItem("sub_cat_id");
    localStorage.removeItem("subcatname");
    localStorage.removeItem("cat_id");
    localStorage.removeItem("isfilter");
  }, []);

  useEffect(() => {
    if (localStorage.getItem("user")) {
      fetchOrderItems();
      fetchFavorites({ type: 0 });
    }
    if (!["page", "partner"].includes(window.location.pathname.split("/")[1])) {
      window.location.href = "/";
    }
  }, []);

  const [pageSelectionInfo, setPageSelectionInfo] = useState();
  useEffect(() => {
    setLoading(true);
    props.changePage({ page: 1 });
    API.getPageSelectionInfoBySlug(slug)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setPage(data.data.data[0]);
          // logEventView(getPageType,data.data?.data[0]?.page_id,data.data.total);
          setPageSelectionInfo(data.data)
          setLoading(false);
        }else{
          setLoading(false);
          window.location.href = "/not-found";
        }
      });
  }, [slug]);
	// console.log(allSelected)
  useEffect(() => {
    if (props.page > 1) {
      getProducts(allSelected);
    }
  }, [slug, window.location.pathname, props.page]);

  useEffect(() => {
    // if (window.location.search) {
    getSearchQuery();
    // }
  }, [slug, window.location.pathname]);
  const [seenProductIds, setSeenProductIds] = useState([]);
  const handleSeenProduct = (id) => {
    setSeenProductIds(prev => {
      if (prev.includes(id)) return prev;
      return [...prev, id];
    });
  };

  useEffect(() => {
    if (deviceType && deviceType.mobile && (seenProductIds.length % 4 == 0)) {
      // console.log("mobile")
      logEventView(getPageType, pageSelectionInfo?.data[0]?.page_id, seenProductIds.length, JSON.stringify(seenProductIds));
    } else if (deviceType && deviceType.tablet && (seenProductIds.length % 8 == 0)) {
      // console.log("tablet")
      logEventView(getPageType, pageSelectionInfo?.data[0]?.page_id, seenProductIds.length, JSON.stringify(seenProductIds));
    } else if (deviceType && deviceType.desktop && (seenProductIds.length % 16 == 0)) {
      // console.log("desktop")
      logEventView(getPageType, pageSelectionInfo?.data[0]?.page_id, seenProductIds.length, JSON.stringify(seenProductIds));
    } 
  }, [seenProductIds])

  if(!page && !loading){
    return <Notfound />
  }else {
    return (
      <>
        <MainContentArea isFullWidth={page?.is_full_width}>
          <div className="p-1 w-100">
            <div className="d-flex mt-2" style={{ width: "100%" }}>
              <Breadcrumb style={{ width: "100%" }}>
                <MButton
                  variant="contained"
                  style={{
                    minWidth: 54,
                    marginInlineEnd: 10,
                    padding: 6,
                    backgroundColor: "#e9ecef",
                  }}
                  onClick={openFilterModal}
                >
                  <Tune style={{ fontSize: 26 }} />
                </MButton>
                <BreadcrumbItem
                  href={"/"}
                  className="home_breadCrumb_style"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {t("shop_address_home_label")}
                </BreadcrumbItem>
                {breadCrumbMatch()}
              </Breadcrumb>
            </div>
          </div>
          {loading ? (
            CenteredSpinner()
          ) : (
            <>
              {isSmallScreen ? (
                page?.small_banner ? (
                  <img src={page?.small_banner} className="img_banner" />
                ) : (
                  <img src={DelishoLogo} className="img_banner" />
                )
              ) : page?.banner ? (
                <img src={page?.banner} className="img_banner" />
              ) : (
                <img src={DelishoLogo} className="img_banner" />
              )}
              <Grid container className="title">
                <Grid item xs={12} className="mt-3">
                  <Typography
                    variant="h4"
                    style={{ fontWeight: "bold" }}
                    color="textPrimary"
                    className="text-center"
                  >
                    {page?.title}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <div
                    className="ql-snow"
                    dangerouslySetInnerHTML={{
                      __html: page?.description,
                    }}
                  ></div>
                </Grid>
              </Grid>
            </>
          )}
          <ContentSection style={{ width: "100%" }}>
            <Suspense fallback={<LazyLoader />}>
              <Products
                type={PAGE_TYPE}
                deviceType={deviceType}
                fetchLimit={16}
                props={props}
                isFilterModal={showFilter}
                toggleFilter={openFilterModal}
                setSelectedBrands={setSelectedBrands}
                queryFilter={queryFilter}
                isFullWidth={page?.is_full_width}
                onSeenProduct={handleSeenProduct}
              />
            </Suspense>
          </ContentSection>
        </MainContentArea>
        <CartPopUp deviceType={deviceType} />
      </>
    );
  }  
};
LandingPartnerPage.getInitialProps = async (appContext) => {
  const { req } = appContext.ctx;
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return { userAgent };
};
const mapStateToProps = (state) => {
  return {
    success: state.authReducer.success,
    modalData: state.productReducer.modalData,
    products: state.productReducer.products,
    allproducts: state.productReducer.allproducts,
	  category: state.productReducer.category,
	  dietary: state.productReducer.dietary,
    sliders: state.globalReducer.sliders,
    loading: state.globalReducer.loading,
    brands: state.productReducer.brands,
    filterBrands: state.productReducer.filterBrands,
    FilteredNameProducts: state.productReducer.FilteredNameProducts,
    filteredProducts: state.productReducer.filteredProducts,
    suggested_subcats: state.productReducer.suggested_subcats,
    oos: state.globalReducer.oos,
    togglesuggestion: state.productReducer.togglesuggestion,
    page: state.productReducer.page,
    cat_refs: state.productReducer.cat_refs,
    isHasMore: state.productReducer.isHasMore,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    productCategory: (data) => productCategory(data, dispatch),
    ProductModalData: (data) => ProductModalData(data, dispatch),
    searchSuggestions: (data) => searchSuggestions(data, dispatch),
    searchStoreProduct: (data) => searchStoreProduct(data, dispatch),
    getProductsMappedwithSubCat: (data) =>
      getProductsMappedwithSubCat(data, dispatch),
    getProductsMappedwithCat: (data) =>
      getProductsMappedwithCat(data, dispatch),
    offerSlider: (data) => offerSlider(data, dispatch),
    getProductOutOfStock: (body) => getProductOutOfStock(body, dispatch),
    getProductOutOfStockCat: (body) => getProductOutOfStockCat(body, dispatch),
    getProductBrands: () => getProductBrands(dispatch),
    getSortProductsName: (type, products) =>
      getSortProductsName(type, products, dispatch),
    getSortProductsPrice: (type, products) =>
      getSortProductsPrice(type, products, dispatch),
    getProductFilterBrands: (
      body,
      products,
      allproducts,
      sub_cat_id,
      cat_id,
      oos,
      text
    ) =>
      getProductFilterBrands(
        body,
        products,
        allproducts,
        sub_cat_id,
        cat_id,
        oos,
        text,
        dispatch
      ),
    sortByNameProduct: (type, products) =>
      sortByNameProduct(type, products, dispatch),
    oosModified: (data) => oosModified(data, dispatch),
    Reset_Suggestions: () => Reset_Suggestions(dispatch),
    changePage: (body) => changePage(body, dispatch),
    resetPage: () => resetPage(dispatch),
    productSelection: (slug, page, limit, qry) =>
      productSelection(slug, page, limit, qry, dispatch),
    productSelectionFilter: (slug, page, limit, qry) =>
      productSelectionFilter(slug, page, limit, qry, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LandingPartnerPage);
